import { InvoicesPanel } from "@/components/organisms";

export const Invoices = () => <InvoicesPanel />;
